import { useState } from "react";
import { toast } from "sonner";
import { Copy, Loader2, Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { streamAI, parseFields } from "../../lib/ai";

const Caption = ({ label, value, onChange, testId }) => (
  <div>
    <div className="flex items-center justify-between">
      <p className="text-sm font-semibold text-ink">{label}</p>
      <button type="button" disabled={!value} onClick={async () => { await navigator.clipboard?.writeText(value); toast.success(`${label} caption copied`); }}
        className="btn-ghost !px-3 !py-1.5 text-xs disabled:opacity-40" data-testid={`${testId}-copy`}><Copy className="h-3.5 w-3.5" /> Copy</button>
    </div>
    <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={9} placeholder="Click Write captions to generate"
      className="mt-2 w-full resize-y rounded-xl border border-ink/15 bg-white px-3.5 py-2.5 text-sm leading-relaxed text-ink outline-none focus:border-ink" data-testid={testId} />
  </div>
);

export const SocialDialog = ({ post, onClose }) => {
  const [li, setLi] = useState("");
  const [ig, setIg] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    setLi("");
    setIg("");
    try {
      await streamAI(`/admin/ai/social/${post.id}`, { url: `${window.location.origin}/blog/${post.slug}` }, (text) => {
        const f = parseFields(text, ["LINKEDIN", "INSTAGRAM"]);
        if (f.LINKEDIN !== undefined) setLi(f.LINKEDIN);
        if (f.INSTAGRAM !== undefined) setIg(f.INSTAGRAM);
      });
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto bg-white" data-lenis-prevent data-testid="social-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Social captions</DialogTitle></DialogHeader>
        <p className="text-sm text-ink/65">For “{post.title}”. Review and edit before posting.</p>
        <button type="button" onClick={run} disabled={busy} className="inline-flex w-fit items-center gap-2 rounded-full bg-navy px-4 py-2 text-xs font-semibold text-white hover:bg-navy-dark disabled:opacity-60" data-testid="social-run">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />} {busy ? "Writing…" : li ? "Rewrite captions" : "Write captions"}
        </button>
        <div className="grid gap-5 md:grid-cols-2">
          <Caption label="LinkedIn" value={li} onChange={setLi} testId="social-linkedin" />
          <Caption label="Instagram" value={ig} onChange={setIg} testId="social-instagram" />
        </div>
      </DialogContent>
    </Dialog>
  );
};
